<nz-spin nzSize="large" nzTip="Submitting..." [nzSpinning]="isLoading">
  <form nz-form nzLayout="vertical" [formGroup]="formGroup" (ngSubmit)="submitForm(formGroup)">
    <nz-form-item>
      <nz-form-label nzRequired>
        Find yourself or a colleague below to assign as responsible for design {{ designId }}:
      </nz-form-label>
      <nz-form-control nzHasFeedback [nzErrorTip]="userErrorTemplate">
        <em-user-search-field formControlName="user"></em-user-search-field>

        <ng-template #userErrorTemplate let-control>
          <ng-container *ngIf="control.errors['required']">Colleague is required</ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-control>
        <button type="submit" nz-button nzType="primary" [disabled]="!formGroup.valid">
          <i nz-icon nzType="save" nzTheme="fill"></i>
          Submit
        </button>
        <button type="button" nz-button (click)="cancel()">Cancel</button>
      </nz-form-control>
    </nz-form-item>
  </form>
</nz-spin>
